"use client";

import Link from "next/link";

import { useTracking } from "@/hooks/use-tracking";
import { schoolGradesTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import { SchoolDetailSalaryScheduleLinkProps } from "@/lib/types/schools.types";

export default function SchoolDetailSalaryScheduleLink({
  salaryScheduleLink,
  schoolId,
}: SchoolDetailSalaryScheduleLinkProps) {
  const { trackSalaryScheduleClicked } = useTracking();

  if (!salaryScheduleLink) {
    return null;
  }

  const handleClick = () => {
    trackSalaryScheduleClicked({
      schoolNcesId: schoolId,
      salaryScheduleUrl: salaryScheduleLink,
    });
  };

  return (
    <Link
      href={salaryScheduleLink}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm sm:text-xs font-medium text-ink-subtle underline underline-offset-2 hover:text-info focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info/30 rounded-sm transition-colors"
      data-testid={`${schoolGradesTestIds.DISTRICT_SALARIES_LINK}-${schoolId}`}
      onClick={handleClick}
    >
      District Salaries
    </Link>
  );
}
